import { Transition } from "@headlessui/react";
import { FC, useState } from "react"

interface FunnelCardWarningProps {
  warningMessages: string[]
}

export const FunnelCardWarning: FC<FunnelCardWarningProps> = ({ warningMessages }) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <div
      className="relative"
      onMouseEnter={() => setIsTooltipOpen(true)}
      onMouseLeave={() => setIsTooltipOpen(false)}
    >
      <span
        className={"text-xs cursor-pointer"}
      >
        ⚠️
      </span>
      <div />
      <Transition show={isTooltipOpen}>
        <div className="absolute bg-yellow-50 border border-yellow-400 text-yellow-700 text-xs top-full -translate-x-1/2 left-0 z-50 w-56 rounded-lg shadow-lg p-3 transition duration-300 ease-in data-closed:opacity-0 data-closed:scale-95">
          <>
            {warningMessages.map(warningMessage =>
              <div className="flex items-stretch gap-2 mb-1 last:mb-0">
                <p>{warningMessage}</p>
              </div>
            )}
          </>
        </div>
      </Transition>
    </div>
  );
}
